import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import API_URL from '../api';
import brandLockup from '../assets/images/company-name.jpg';

function CompleteRecruiterProfile() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [form, setForm] = useState({ company_name: '', role: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!state?.id_token) return <Navigate to="/login?role=recruiter" replace />;

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post(`${API_URL}/api/auth/google/recruiter/complete`, {
        id_token: state.id_token,
        company_name: form.company_name,
        role: form.role,
      });
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      navigate('/recruiter/dashboard', { replace: true });
    } catch (err) {
      const msg = err.response?.data?.error || 'Something went wrong. Please try again.';
      const existingRole = err.response?.data?.existing_role;
      if (existingRole === 'student') {
        setError(msg + ' You will be redirected to the login page.');
        setTimeout(() => navigate('/login?role=student', { replace: true }), 2500);
      } else {
        setError(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <img src={brandLockup} alt="HyrSkill" className="auth-logo-img" />

      <div className="auth-card" style={{ maxWidth: 440 }}>
        {state.picture && (
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            <img
              src={state.picture}
              alt={state.name}
              style={{ width: 64, height: 64, borderRadius: '50%', objectFit: 'cover' }}
            />
          </div>
        )}
        <h1 style={{ textAlign: 'center' }}>One last step, {state.name?.split(' ')[0]}!</h1>
        <p className="auth-sub" style={{ textAlign: 'center' }}>
          Tell us about your company so students can find your job posts.
        </p>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Company name *</label>
            <input
              type="text"
              value={form.company_name}
              onChange={e => set('company_name', e.target.value)}
              placeholder="e.g. Acme Technologies"
              required
            />
          </div>

          <div className="form-group">
            <label>
              Your role&nbsp;
              <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>(optional)</span>
            </label>
            <input
              type="text"
              value={form.role}
              onChange={e => set('role', e.target.value)}
              placeholder="e.g. Founder, Hiring Manager, HR"
            />
          </div>

          <button type="submit" className="btn btn-full" style={{ marginTop: 8 }} disabled={loading}>
            {loading
              ? <><span className="spinner" style={{ width: 16, height: 16, borderWidth: 2 }} /> Creating account…</>
              : 'Complete Sign Up'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CompleteRecruiterProfile;
